div
<template>
  <div>
    <div class="card-header">
      <div class="d-flex justify-content-end align-items-center">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div class="referral-filter">
            <multi-select
              v-model="filterTags"
              tag-placeholder="Tags"
              :placeholder="$t('tags')"
              label="name"
              :options="tags"
              track-by="name"
              :multiple="true"
            />
          </div>
          <div>
            <input
              autocomplete="off"
              type="text"
              name="search"
              class="form-control"
              :placeholder="$t('search')"
              v-model="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!--==================================-->
    <div class="dextop-table-view">
      <!-- table -->
      <div class="table-responsive referral-table api-keys-table mt-2">
        <vue-good-table
          styleClass="vgt-table striped"
          :columns="columns"
          :fixed-header="false"
          :rows="rows"
          :pagination-options="{
            enabled: false,
            perPage: pageLength,
          }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
        >
          <div slot="emptystate" style="text-align: center">
            {{ $t("noDataForTable") }}
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'costs'">{{
              $formatter(props.row.costs)
            }}</span>
            <span v-else-if="props.column.field === 'Company.companyName'">
              {{ props.row.reseller }}
            </span>
            <span v-else-if="props.column.field === 'referralTag'">
              <span
                v-for="(tag, index) in formatTags(props.row.referralTag)"
                :key="index"
                class="badge bg-success me-1"
              >
                {{ tag }}
              </span>
            </span>
            <span v-else-if="props.column.field === 'createdAt'">
              <p class="">
                {{ $dateFormatter(props.row.createdAt, $i18n.locale) }}
              </p>
            </span>
            <span
              class="d-flex align-items-center justify-content-center gap-2"
              v-else-if="props.column.field === 'action'"
            >
              <div
                class="cursor-pointer"
                v-if="$can(`backoffice-company.edit`)"
                @click="$router.push(`/customers/${props.row.id}/edit`)"
              >
                <feather-icon size="16" icon="Edit2Icon" />
              </div>
            </span>
            <span
              v-else-if="props.column.field === 'invoiceSum'"
              style="white-space: nowrap"
            >
              {{
                $formatter(
                  props.row.invoiceSum,
                  $i18n.locale,
                  "EUR",
                  false,
                  2,
                  2
                )
              }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props"> </template>
        </vue-good-table>
        <table class="table w-100 mt-1">
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="font-weight: bold; white-space: nowrap">
                {{
                  $formatter(totalInvoiceSum, $i18n.locale, "EUR", false, 2, 2)
                }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-form-group>
          <div class="d-flex align-items-center">
            <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
            <b-form-select
              v-model="pageLength"
              :options="['25', '50', '100']"
              class="ml-1"
              @input="(value) => onPerPageChange({ pageLength: value })"
            />
          </div>
        </b-form-group>
        <div>
          <b-pagination
            :value="1"
            :total-rows="totalRecords"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => onPageChange({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="reponsive-view-cards">
      <b-row>
        <b-col
          cols="12"
          lg="4"
          md="6"
          v-for="row in rows"
          :key="row.id"
        >
          <div class="card mb-1">
            <div class="card-header d-flex align-items-center justify-content-between">
              <h5 class="card-title">{{ row.companyNumber }}</h5>
              <div class="d-flex gap-2">
                <feather-icon

                  class="cursor-pointer"
                  v-if="$can(`backoffice-company.edit`) && !isShow"
                  @click="$router.push(`/customers/${row.id}/edit`)"
                  size="18"
                  icon="Edit2Icon"
                />
              </div>
            </div>

            <div class="card-body pt-0">
              <ul class="card-list">
                <li>
                  <div class="left">
                    <strong>{{ $t("companyName") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.companyName }}</span>
                  </div>
                </li>

                <li>
                  <div class="left">
                    <strong>{{ $t("referralLink") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.referralName }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("role") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.role }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("tags") }}: </strong>
                  </div>
                  <div class="right">
                    <span
                      v-for="(tag, index) in formatTags(row.referralTag)"
                      :key="index"
                      class="badge bg-success me-1"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </li>

                <li>
                  <div class="left">
                    <strong>{{ $t("registrationDate") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{
                      $dateFormatter(row.createdAt, $i18n.locale)
                    }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("overallInvoiceAmount") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{
                      $formatter(
                        row.invoiceSum,
                        $i18n.locale,
                        "EUR",
                        false,
                        2,
                        2
                      )
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-center mt-2">
            <b-pagination
              :value="1"
              :total-rows="totalRecords"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => onPageChange({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <!--==================================-->
  </div>
</template>
<script>
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import { props } from "vue-prism-component";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import { debounce } from "@/utils/debounce";

export default {
  components: {
    PageHeader,
    MultiSelect,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [fileHandlerMixin],
  computed: {
    columns() {
      const cols = [
        {
          label: this.$t("companyNumber"),
          field: "companyNumber",
        },
        {
          label: this.$t("companyName"),
          field: "companyName",
        },
        {
          label: this.$t("referralLinks"),
          field: "referralName",
          sortable: false,
        },
        {
          label: this.$t("role"),
          field: "role",
          sortable: false,
        },
        {
          label: this.$t("tags"),
          field: "referralTag",
          sortable: false,
        },
        {
          label: this.$t("registrationDate"),
          field: "createdAt",
        },
        {
          label: this.$t("overallInvoiceAmount"),
          field: "invoiceSum",
          sortable: false,
        },
      ];
      if (!this.isShow) {
        cols.push({
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        });
      }

      return cols;
    },
  },
  watch: {
    search() {
      this.debouncedFetch();
    },
    filterTags() {
      this.debouncedFetch();
    },
  },
  data() {
    return {
      totalRecords: 0,
      pageLength: 25,
      totalInvoiceSum: 0.0,
      page: 1,
      tags: [],
      filterTags: [],
      form: {
        sortBy: "createdAt",
        sortOrder: "desc",
      },

      rows: [],
      companyId: localStorage.getItem("company_id"),
      referralServiceBaseUrl: process.env.VUE_APP_REFERRAL_BASEURL || "",
      search: "",
    };
  },

  async created() {
    this.debouncedFetch = debounce(async (newValue, oldValue) => {
      try {
        await this.loadItems();
      } catch (e) {
        console.error(e);
      }
    }, 300);
    this.loadItems();
  },

  methods: {
    formatTags(tags) {
      if (!tags) return [];

      if (Array.isArray(tags)) {
        return tags.map((tag) => tag.name || tag);
      }

      // If it's a comma-separated string
      return tags.split(",").map((tag) => tag.trim());
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },
    async loadCompanyLogo() {
      await this.$store
        .dispatch("customers/show", this.companyId)
        .then((res) => {
          let data = res?.data?.modelData;
          if (data.image) {
            this.getImage(data.image.id, "fileSrc", this.image);
          }
        });
    },
    onSortChange(params) {
      this.form.sortOrder = params[0].type;
      if (params[0].type == "none") this.form.sortOrder = "asc";
      this.form.sortBy = params[0].field;
      if (params[0].field == "salesPartner") {
        this.form.sortBy = "Company.companyName";
      }
      this.loadItems();
    },

    // load items is what brings back the rows from server
    async loadItems() {
      try {
        const selectedTags = this.filterTags.map((tag) => tag.name);
        const companyId = this.$route?.params?.id;
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch("customers/listReferrals", {
          page: this.page,
          ...this.form,
          searchReferral: this.search,
          filterTags: selectedTags,
          perPage: this.pageLength,
          ...(companyId ? { companyId } : {}), // Conditionally add companyId
        });
        this.rows = response?.data?.data;
        this.totalInvoiceSum = response?.data?.totalInvoiceSum;
        this.totalRecords = response?.data?.total;
        this.tags = response?.data?.tags;
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
  },
};
</script>
